import { AvailabilityType } from '@bariendo/lib/scheduling';
import { Coding, Location, Practitioner, Reference } from '@medplum/fhirtypes';

export type AvailabilityModality = 'Virtual' | 'In Person';

export interface TimeRange {
  startTime: string; // "09:00" format (from TimeInput) or "09:00:00" format (for API)
  endTime: string; // "17:00" format (from TimeInput) or "17:00:00" format (for API)
  appointmentTypes: Coding[];
}

export interface BaseAvailabilityFormData {
  practitioner: Reference<Practitioner> | null;
  encounterClass: Coding;
  timezone: string;
  location: Reference<Location> | null;
}

export type DayOfWeek = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export interface DayAvailability {
  dayOfWeek: DayOfWeek;
  enabled: boolean;
  timeRanges: TimeRange[];
}

export interface WeeklyAvailabilityFormData extends BaseAvailabilityFormData {
  days: DayAvailability[];
}

export interface OneTimeAvailabilityFormData extends BaseAvailabilityFormData {
  date: string; // ISO date string (YYYY-MM-DD)
  startTime: string; // HH:mm format
  endTime: string; // HH:mm format
  appointmentTypes: Coding[];
  /** Optional scheduler-facing guideline note, stored as a sub-extension on the Slot. */
  schedulingGuideline?: string;
}

export const DAYS_OF_WEEK: Array<{ value: DayOfWeek; label: string }> = [
  { value: 'sun', label: 'Sun' },
  { value: 'mon', label: 'Mon' },
  { value: 'tue', label: 'Tue' },
  { value: 'wed', label: 'Wed' },
  { value: 'thu', label: 'Thu' },
  { value: 'fri', label: 'Fri' },
  { value: 'sat', label: 'Sat' },
];

export interface AvailabilityEntry {
  id: string;
  type: AvailabilityType;
  location: string | undefined;
  locationReference: string | undefined;
  modality: AvailabilityModality;
  schedule: string | string[]; // For weekly: array of day/time strings, for one-time: single date/time string
  services?: string[]; // Only for one-time availabilities
}

export interface ProviderAvailability {
  providerId: string;
  providerName: string;
  providerInitials: string;
  providerScheduleReference: string | undefined;
  availabilities: AvailabilityEntry[];
}
